import { c as _c } from "react/compiler-runtime";
import { FOCUS_RING } from '@common/components/interaction';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { GoodsLockup } from '@/app/donation/_components/GoodsLockup';
import { GOODS_EVENT_LANDING_HREF } from '@/constants/yearEndDonationHome';

//* 채널 판정은 첫 페인트 전에 정해지는 data-partner CSS로 한다 — 하이드레이션 뒤 판정하면 헤더 위에서 띠가 늦게 끼어들어 화면이 밀린다
export const GoodsEventTopBand = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CustomLink prefetch={false} href={GOODS_EVENT_LANDING_HREF} className={cn("flex w-full items-center justify-center gap-12 bg-[#e6f9d4] px-40 py-16", "transition-[filter] duration-150 hover:brightness-95 active:brightness-95 motion-reduce:transition-none", "mobile-tablet:hidden kbpay:hidden toss:hidden kakaobank:hidden", FOCUS_RING)}><GoodsLockup className="text-[1.125rem]" /><span className="font-700 text-Gray-900 typo-body2">10만원 기부하면 웰로x카카오프렌즈 다이어리 증정! (11.02~소진시까지)</span></CustomLink>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};